import React, { useState ,useEffect, useRef} from 'react';
import * as Yup from "yup";
import { Row, Col, Table,Container } from "react-bootstrap";
import InputField from "../InputField/InputField";
import SlectInputField from "../SlectInputField/SlectInputField";
import TextareaField from "../TextareaField/TextareaField";
import { Formik, Field } from "formik";
import { Flip, Slide, toast } from 'react-toastify';
import { useParams , useSearchParams,useNavigate } from "react-router-dom";
import CustomDateTimePicker from '../InputField/CustomDateTimePicker';
import Axios from '../../lib/axios/axiosInstance';
import Request from './Request';

const CorporateformSchema = Yup.object().shape({
  type: Yup.string().required("Type is required"),
  subject: Yup.string().required("Subject is required"),
  body: Yup.string().required("Message is required"),
});

const RequestDetails = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const [details, setDetails] = useState(false)
    const [reqDate,setReqDate] = useState(new Date())
    const [initialValue, setInitialValue] = useState({
        type: "",
        subject: "",
        body: "",
    });

  const updateFormSubmitHandler = async (values,resetForm) => {
    
    var val = {
        "request": {
            type: values.type,
            subject: values.subject,
            message: values.body,
        }
    }
    // Submit New Request
    // api/account/request
    await Axios.post('/account/request/',val)
    .then(async (response) =>{
      if (response && response.status == 200 && response.data.data?.request?.refnum) {
        toast.success('Request sended successfully !', {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 4000,
          transition: Slide,
        });
      }
      else {
        toast.error('Something went Wrong!', {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 3000,
          transition: Flip,
        })
      }
    });
  };

  useEffect(async () => {
    if(searchParams.get("refnum")){
        // View Request
        // api/account/request/:refnum
        debugger;
        const refnum=searchParams.get("refnum");
        setDetails(refnum)
        // await Axios.get(`/account/request/${searchParams.get("refnum")}`)
        // .then(async (response) =>{
        //   debugger;
        // if (response && response.status == 200 && response.data.data?.request) {
        //     setInitialValue({
        //         type: response.data.data?.request.type,
        //         subject: response.data.data?.request.subject,
        //         body: response.data.data?.request.message
        //     })
        //     setDetails(response.data.data?.request)
        // }
        // else {
        //     toast.error('Something went Wrong!', {
        //     position: toast.POSITION.TOP_CENTER,
        //     autoClose: 3000,
        //     transition: Flip,
        //     })
        // }
        // });
    }
  }, [searchParams.get("refnum")]);

  return (
    <>
    <section className="main-container col1-layout">
            <Container className="main">
                <div className="col-main">
                    <div className="shopping-cart-inner">
                        
                        <div className="page-content">
                            <div className="page-content checkout-page">
                                
                                {/* <Formik
                                  initialValues={initialValue}
                                  validationSchema={CorporateformSchema}
                                  onSubmit={(values, { setSubmitting,resetForm  }) => {
                                    // console.log(values);
                                    updateFormSubmitHandler(values,resetForm);
                                    setSubmitting(false);
                                  }}
                                  enableReinitialize
                                >
                                  {({
                                    values,
                                    errors,
                                    touched,
                                    handleChange,
                                    handleBlur,
                                    handleSubmit,
                                    isSubmitting,
                                    setFieldValue,
                                  }) => (
                                    <form onSubmit={handleSubmit}>
                                      <Col xl={12} sm={12} xs={12}>
                                          <Row>
                                              <Col xl={12} sm={12} md={12}>
                                                  <Row>
                                                      <Col xl={4} sm={4} md={4}>Ticket #</Col>
                                                      <Col xl={8} sm={8} md={8}>
                                                      <input
                                                          Type="text"
                                                          readOnly={true}
                                                          value={details.refnum}
                                                          className='form-control'
                                                      />
                                                      </Col>
                                                  </Row>   
                                              </Col>
                                              
                                              <Col xl={12} sm={12} md={12}>
                                                <Row>
                                                  <Col xl={4} sm={4} md={4}>Type</Col>
                                                  <Col xl={8} sm={8} md={8}>
                                                      <input
                                                          Type="text"
                                                          readOnly={true}
                                                          value={details.type}
                                                          className='form-control'
                                                      />
                                                  </Col>
                                                </Row>   
                                              </Col>
                                              <br/>
                                              <br/>
                                              <Col xl={12} sm={12} md={12}>
                                                <Row>
                                                  <Col xl={4} sm={4} md={4}>Subject</Col>
                                                  <Col xl={8} sm={8} md={8}>
                                                      <input
                                                          Type="text"
                                                          readOnly={true}
                                                          value={details.subject}
                                                          className='form-control'
                                                      />  
                                                  </Col>
                                                </Row>   
                                              </Col>

                                              <Col xl={12} sm={12} md={12}>
                                                <Row>
                                                  <Col xl={4} sm={4} md={4}>Message</Col>
                                                  <Col xl={8} sm={8} md={8}>
                                                      <textarea
                                                          rows={15}
                                                          Type="text"
                                                          readOnly={true}
                                                          value={details.message}
                                                          className='form-control'
                                                      />
                                                  </Col>
                                                </Row>   
                                              </Col>
                                              <br/>
                                              <Col xl={12} sm={12} md={12}>
                                                <Row>
                                                  <Col xl={4} sm={4} md={4}>Date</Col>
                                                  <Col xl={8} sm={8} md={8}>
                                                  <CustomDateTimePicker 
                                                    startYear={1970}
                                                    value={new Date(reqDate)}
                                                    onChange={(e)=>{handleChange({type:"change",target:{value:e}}); setReqDate(e)}}
                                                    className={(errors.date && touched.date ) ? 'is-invalid' : 'form-control'}
                                                  />
                                                  </Col>
                                                </Row>   
                                              </Col>
                                              <Col xl={12} sm={12} md={12}>
                                                <Row>
                                                  <Col xl={4} sm={4} md={4}>Type</Col>
                                                  <Col xl={8} sm={8} md={8}>
                                                    <SlectInputField
                                                      Name="type"
                                                      placeHolder="Select Type"
                                                      options={[
                                                        { label: "Enquiries", value:  "Enquiries"},
                                                        { label: "Feedback", value:  "Feedback"},
                                                        { label: "Compliment", value:  "Compliment"}
                                                      ]}
                                                      value={values.type}
                                                      onChange={e=>{handleChange(e); }}
                                                      onBlur={handleBlur}
                                                      className={
                                                        (errors.type && touched.type
                                                          ? " is-invalid"
                                                          : "")
                                                      }
                                                    />
                                                  </Col>
                                                </Row>   
                                              </Col>
                                              <Col xl={12} sm={12} md={12}>
                                                <Row>
                                                  <Col xl={4} sm={4} md={4}>Reply</Col>
                                                  <Col xl={8} sm={8} md={8}>
                                                    <TextareaField
                                                      Rows={15}
                                                      Name="body"
                                                      id="body"
                                                      Type="text"
                                                      value={values.body}
                                                      onChange={handleChange}
                                                      isInvalid={!!errors.body}
                                                      className={(errors.body && touched.body) ? 'is-invalid customTextArea' : 'form-control customTextArea'}
                                                    />
                                                  </Col>
                                                </Row>   
                                              </Col>
                                            </Row>
                                          </Col>

                                      <Col xl={12} sm={12} xs={12}>
                                        <Row>
                                          
                                          <Col xl={12} sm={12}>
                                            <button type="submit" className="button" style={{float:"right"}}>
                                              Send Reply
                                            </button>
                                          </Col>
                                        </Row>
                                      </Col>
                                    </form>
                                  )}
                                </Formik> */}
                                {details && <Request showDetailsId={details}/>}

                            </div>
                        </div>
                    </div>
                </div>
            </Container >

        </section >
    </>
  );
};

export default RequestDetails;
